"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorMessage = void 0;
const react_1 = __importDefault(require("react"));
const polaris_1 = require("@shopify/polaris");
const ordersCopy_1 = require("copy/ordersCopy");
const ErrorMessage = () => (react_1.default.createElement(polaris_1.Banner, { title: 'Cannot load orders', tone: 'critical' },
    react_1.default.createElement("p", null, ordersCopy_1.ordersCopy.fetchError)));
exports.ErrorMessage = ErrorMessage;
